import { Chat as UIChat } from '@vk-hr-tek/ui/Chat';
import { loadChat, selectStatus } from '@vk-hr-tek/core/chat';

import { useDispatch, useSelector } from '@app/hooks';
import { useIsQuizRoute } from '@app/hooks/useIsQuizRoute';
import { useIsCommunityRoute } from '@app/hooks/useIsCommunityRoute';

import { useIsChatHidden } from '../hooks';

export const Chat = () => {
  const dispatch = useDispatch();
  const isQuizRoute = useIsQuizRoute();
  const isCommunityRoute = useIsCommunityRoute();
  const isHidden = useIsChatHidden();

  const status = useSelector(selectStatus);

  const loadWebim = () => dispatch(loadChat());

  // Скрываем чат на страницах
  if (isQuizRoute || isCommunityRoute || isHidden) {
    return null;
  }

  return (
    <UIChat
      status={status}
      loadWebim={loadWebim}
      webimAccountName={window.REACT_APP_VKHRTEK_WEBIM_ACCOUNT_NAME}
    />
  );
};
